import { render } from "./PrivacyGuest.vue?vue&type=template&id=0eb4b437"
import script from "./PrivacyGuest.vue?vue&type=script&lang=js"
export * from "./PrivacyGuest.vue?vue&type=script&lang=js"
script.render = render

export default script